import React, { Component } from 'react';
import RightSearchBar from '../components/RightSearchBar';
import MapCardChoropleth from '../components/MapCardChoropleth';
import Base from './Base';
import UserStore from "../stores/UserStore";
import LoadingScreen from '../components/LoadingScreen'; // Import the LoadingScreen component

require('dotenv').config()

class Mapstat extends Component {

  constructor() {
  super();
  this.convertGeoJson = this.convertGeoJson.bind(this);
  this.state = {
      mapSouthWest: { lat: null, lng: null },
      mapNorthEast: { lat: null, lng: null },
      mapMinZoom:5,
      geojson: {},
       dataColumns:[],
       searchCriteria: [{name:'Successionsmarknad', id:0, pageClass: 'card' , fields:{
               'area_category':{'value':'2', 'title':'Områdestyp', 'type':'dropdown',
                   'options':[
                       {'name':'Delomraden sverige','value':'2'},
                       {'name':'Deso','value':'1'},
                       {'name':'kv100','value':'3'}
                   ], 'placeholder':'countyg'},
              'housing_type':{'value':'apt', 'title':'Bostadstyp', 'type':'dropdown',
                  'options':[
                      {'name':'Villor/radhus','value':'house'},
                      {'name':'Bostadsrätter','value':'apt'},
                      {'name':'1 Rok','value':'oneroom'},
                      {'name':'2 Rok','value':'tworoom'},
                      {'name':'3 Rok','value':'threeroom'},
                      {'name':'4 Rok','value':'fourroom'},
                      {'name':'5 Rok','value':'fiveroom_plus'},
                      {'name':'Totalt','value':'total'}
                  ]},

              'method':{'value':'avg_recounted_psqm_n_best', 'title':'Metod', 'type':'dropdown',
                  'options':[
                      {'name':'Kvadratmeterpris - medel','value':'avg_recounted_psqm_n_best'},
                      {'name':'Pris - medel', 'value':'avg_recounted_price_n_best'},
                      {'name':'Månadsavgift - medel', 'value':'mean_yearly_fee_sales'},
                      {'name':'Byggår - medel', 'value':'sales_byear_mean'},
                      {'name':'Boarea - medel', 'value':'mean_area_sales_n_best'},
                      {'name':'Antal försäljningar per år', 'value': 'number_of_sales_per_year'}
                  ]},
               'valid_at':{'value':'2023-03-15', 'title':'Datum', 'type':'dropdown',
                   'options':[{'name':'2022-01','value':'2022-01-15'},
                       {'name':'2022-02','value':'2022-02-15'},
                       {'name':'2022-03','value':'2022-03-15'},
                       {'name':'2022-04','value':'2022-04-15'},
                       {'name':'2022-05','value':'2022-05-15'},
                       {'name':'2022-06','value':'2022-06-15'},
                       {'name':'2022-07','value':'2022-07-15'},
                       {'name':'2022-08','value':'2022-08-15'},
                       {'name':'2022-09','value':'2022-09-15'},
                       {'name':'2022-10','value':'2022-10-15'},
                       {'name':'2022-11','value':'2022-11-15'},
                       {'name':'2022-12','value':'2022-12-15'},
                       {'name':'2023-01','value':'2023-01-15'},
                       {'name':'2023-02','value':'2023-02-15'},
                       {'name':'2023-03','value':'2023-03-15'}

                   ]},
              'dynamic_colour':{'value':true, 'title':'Dynamisk färgskala', 'type':'checkbox'},
               'lock_colour':{'value':false, 'title':'Lås färgskala', 'type':'checkbox'}
          }}],
      colorMapping: [],
       mapPositionLat: 59.274472,
       mapPositionLng: 17.944866,
       mapZoomLevel: 13,
       searchInProgress: false,
       dynamicColours: true,
       lockedColours: false
     }
     this.makeMapstatSearch = this.makeMapstatSearch.bind(this);
     this.updateSearchCriteria = this.updateSearchCriteria.bind(this);
     this.getPolygonColor = this.getPolygonColor.bind(this);
     this.updateValidDatesForCategoryAndFields = this.updateValidDatesForCategoryAndFields.bind(this);

  }

    onMapMoveBounds = (southWest, northEast) => {
        this.setState({
            mapSouthWest: {
                lat: southWest.lat,
                lng: southWest.lng
            },
            mapNorthEast: {
                lat: northEast.lat,
                lng: northEast.lng
            }
        });
    }

    convertGeoJson(geoJson,dataInformation){
      let newFeatures = [];
      //console.log(geoJson.features);
      for(let feature of geoJson.features) {
        //console.log(feature);
          newFeatures.push({type:feature.geometry.type,coordinates:feature.geometry.coordinates,properties:dataInformation[feature.properties.id]});
      }
      geoJson.features=newFeatures;
      return geoJson;
    }

 updateSearchCriteria(event){
     let tmp_searchCriteria = this.state.searchCriteria;
     let sectionid = event.target.attributes.getNamedItem('sectionid').value;
     if(event.target.attributes.getNamedItem('class').value == "form-check-input"){
         if(event.target.attributes.getNamedItem('name').value == "dynamic_colour"){
             tmp_searchCriteria[sectionid]['fields'][event.target.name]['value'] = !this.state.dynamicColours
             this.setState({dynamicColours:!this.state.dynamicColours})

         }else if(event.target.attributes.getNamedItem('name').value == "lock_colour"){
             tmp_searchCriteria[sectionid]['fields'][event.target.name]['value'] = !this.state.lockedColours
             this.setState({lockedColours:!this.state.lockedColours})
             //alert(event.target.value)
         }
     }else{
         tmp_searchCriteria[sectionid]['fields'][event.target.name]['value'] = event.target.value
     }

   this.setState({searchCriteria: tmp_searchCriteria});
     // > Update the dates in the menu
     // Check if we changed field or category
     if(event.target.name == "area_category" || event.target.name == "housing_type" || event.target.name == "method"){
        this.updateValidDatesForCategoryAndFields();
     }

   // TODO Does not work right now
   if(event.target.name == "area_category"){
       if(event.target.value == 3){
           this.setState({mapMinZoom:2})
       }else{
           this.setState({mapMinZoom:5})
       }

   }
 }
    getPolygonColor(d){
        for (let i = 0; i < this.state.colorMapping.length; i++) {
            //console.log(d + " vs " + this.state.colorMapping[i].threshold);
            if (Number(d) < this.state.colorMapping[i].threshold) {
                //console.log(this.state.colorMapping[i].color);
                return this.state.colorMapping[i].color;
            }
        }
        console.log(d);
        console.log(this.state.colorMapping[this.state.colorMapping.length -1 ].threshold);
        if (Number(d) >= this.state.colorMapping[this.state.colorMapping.length -1 ].threshold){
            return this.state.colorMapping[this.state.colorMapping.length -1].color
        }else{
            return '#FFEDA0'; // default color
        }
    }

    generateColorRange(minValue, maxValue, step, minColor, maxColor) {
        let range = [];
        const totalSteps = (maxValue - minValue) / step;

        // Convert hex color to RGB
        function hexToRgb(hex) {
            const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        }

        const minColorRgb = hexToRgb(minColor);
        const maxColorRgb = hexToRgb(maxColor);

        for (let i = 0; i <= totalSteps; i++) {
            let currentValue = minValue + step * i;
            let valueRatio = i / totalSteps;

            // Interpolate the color
            const r = minColorRgb.r + (maxColorRgb.r - minColorRgb.r) * valueRatio;
            const g = minColorRgb.g + (maxColorRgb.g - minColorRgb.g) * valueRatio;
            const b = minColorRgb.b + (maxColorRgb.b - minColorRgb.b) * valueRatio;

            // Convert back to hex
            function rgbToHex(r, g, b) {
                return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
            }

            let color = rgbToHex(Math.round(r), Math.round(g), Math.round(b));
            range.push({ threshold: currentValue, color: color });
        }

        return range;
    }

updateValidDatesForCategoryAndFields = () =>{
    // Save current date (selected)
    let current_date_selected = this.state.searchCriteria[0].fields.valid_at.value;
    let category_id = this.state.searchCriteria[0].fields.area_category.value;
    let information_field_name  = this.state.searchCriteria[0].fields.method.value + "_" + this.state.searchCriteria[0].fields.housing_type.value
    // Get field id
    fetch(global.apiUrl + '/v1/area/information/field?names=' +information_field_name+  '&access_token=' + UserStore.access_token)
        .then(res => res.json())
        .then((data) => {
            //console.log(data['area_information_fields'][0]['id']);
            let information_field_id = data['area_information_fields'][0]['id'];
            // Fetch other dates
            let date_list = [];
            fetch(global.apiUrl + '/v1/area/information/dates?field_ids=' + information_field_id + '&category_ids=' + category_id + '&access_token=' + UserStore.access_token)
                .then(res => res.json())
                .then((data) => {
                    date_list = data.area_information_dates.map(item => {
                        return {'name': item.valid_from.substring(0, 7), 'value': item.valid_from}
                    }).sort((a, b) => {
                        return b.value.localeCompare(a.value);
                    });
                    // If the same one is available, we select it as active
                    let tmp_searchCriteria = this.state.searchCriteria;
                    tmp_searchCriteria[0].fields.valid_at.options =  date_list;
                    if(!date_list.some(item => item.name === current_date_selected.substring(0, 7)) && date_list.length > 0){
                        //tmp_searchCriteria[0].fields.valid_at.value = date_list[0].value;
                        alert("No data found for the date ==> " + current_date_selected.substring(0, 7));
                    }else{
                        tmp_searchCriteria[0].fields.valid_at.value = date_list[0].value;
                    }
                    this.setState({searchCriteria: tmp_searchCriteria});
                });
        });
  }

  makeMapstatSearch = () =>{

    if(this.state.searchInProgress) {
        //alert("You need to wait before the earlier one finishes");
        console.log("You need to wait before the earlier one finishes")
        return
    }
      this.setState({searchInProgress:true})
    //console.log(this.state.searchCriteria[0].fields.area_category.value);
    let category_id = this.state.searchCriteria[0].fields.area_category.value;
    let information_field_name  = this.state.searchCriteria[0].fields.method.value + "_" + this.state.searchCriteria[0].fields.housing_type.value
    //console.log(information_field_name);
    let lat_min = this.state.mapSouthWest.lat;
    let lat_max = this.state.mapNorthEast.lat;
    let lon_min = this.state.mapSouthWest.lng;
    let lon_max = this.state.mapNorthEast.lng;


    let valid_at = this.state.searchCriteria[0].fields.valid_at.value;
      fetch(global.apiUrl + '/v1/area/information/field?names=' +information_field_name+  '&access_token=' + UserStore.access_token)
          .then(res => res.json())
          .then((data) => {
              //console.log(data['area_information_fields'][0]['id']);
              let information_field_id = data['area_information_fields'][0]['id'];

              let field_colour_max_value = data['area_information_fields'][0]['colour_max_value'];
              let field_colour_min_value = data['area_information_fields'][0]['colour_min_value'];
              let field_colour_unit = data['area_information_fields'][0]['colour_unit'];
              let field_max_colour = data['area_information_fields'][0]['max_colour'];
              let field_min_colour = data['area_information_fields'][0]['min_colour'];

              fetch(global.apiUrl + '/v1/area/map?category_ids=' + category_id + '&information_field_id=' + information_field_id + '&min_wgs84lat=' + lat_min + '&max_wgs84lat=' + lat_max + '&min_wgs84lon=' + lon_min + '&max_wgs84lon=' + lon_max + '&valid_at=' + valid_at +  '&access_token=' + UserStore.access_token)
                  .then(res => res.json())
                  .then((data) => {

                      let dataList = [];
                      let features = data['area_map']['features'];
                      let step = null;
                      let minDataValue = null;
                      let colourValues = []
                      //alert(this.state.lockedColours)
                      //alert(this.state.dynamicColours)
                      if(!this.state.lockedColours){
                          if(this.state.dynamicColours){
                              for(let feature_nr = 0; feature_nr < features.length; feature_nr++) {
                                  dataList.push(features[feature_nr]['properties']['field_value']);
                              }

                              // Calculate statistics
                              const maxDataValue = Math.max(...dataList);
                              const minDataValue = Math.min(...dataList);
                              //console.log("Max Value:", maxDataValue);
                              //console.log("Min Value:", minDataValue);

                              const colourValues = ['#FFEDA0', '#FED976', '#FEB24C', '#FD8D3C', '#FC4E2A', '#E31A1C', '#BD0026', '#800026'];
                              const step = (maxDataValue - minDataValue) / (colourValues.length - 1);
                              const newColourMapping = colourValues.map((colour, index) => {
                                  return {
                                      threshold: minDataValue + index * step,
                                      color: colour
                                  };
                              });
                              this.setState({colorMapping:newColourMapping});
                              //console.log(newColourMapping);
                              // Generate the colorMapping
                          }else{
                              let newColourMapping = this.generateColorRange(field_colour_min_value, field_colour_max_value, field_colour_unit, field_min_colour, field_max_colour)
                              // console.log(newColourMapping)

                              this.setState({colorMapping:newColourMapping});
                              //console.log(newColourMapping);
                          }
                      }


                      //console.log(data);
                      this.setState({geojson:{}});
                      this.setState({geojson:data['area_map']});
                      //console.log(this.state.colorMapping)
                      this.setState({searchInProgress:false});
                  })
                  .catch(error => {
                      console.log(error);
                      this.setState({searchInProgress:false});
                  });
          })
          .catch(error => {
              console.log(error);
              this.setState({searchInProgress:false});
          });


  }


  componentDidMount() {
      this.updateValidDatesForCategoryAndFields();
  }

  render() {

      return (
        <Base pageTopic={"Mapstat"} mainContent={ <>
          {this.state.searchInProgress && <LoadingScreen></LoadingScreen>}
          <MapCardChoropleth geojson={this.state.geojson['features']}
                             lonName={"lon"}
                             latName={"lat"}
                             markerTitle={this.state.markerTopic}
                             markerPopupColumns={this.state.dataColumns}
                             mapPositionLat={this.state.mapPositionLat}
                             mapPositionLng={this.state.mapPositionLng}
                             mapZoomLevel={this.state.mapZoomLevel}
                             mapMinZoom={this.state.mapMinZoom}
                             onMapMoveBounds={this.onMapMoveBounds}
                             getPolygonColor={this.getPolygonColor}></MapCardChoropleth>
          </>}
          searchBar={ <RightSearchBar searchCriteria={this.state.searchCriteria} updateSearchCriteria={this.updateSearchCriteria} searchFunction={this.makeMapstatSearch}  colorMapping={this.state.colorMapping}></RightSearchBar>
        }></Base>
	     )
  }
}

export default Mapstat;
